import type { AxiosError } from 'axios';
import { HttpAxiosClient } from '@/services/api/clients/HttpAxiosClient';

export class HttpAxiosLoggingClient extends HttpAxiosClient {
  protected onError(error: AxiosError): void {
    console.error(error); // make sure we do not throw any errors, cuz it will result in a loop
  }
}
